import { campaignFailureReason } from '@/features/campaigns/v2/Whatsapp/Campaigns/campaignStatus';
import type { CampaignV2Response } from '@/services/endpoints/campaigns/types';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { HiOutlineExclamationCircle } from 'react-icons/hi';
import { twMerge } from 'tailwind-merge';

type CampaignFailureCalloutProps = {
  campaign: Pick<CampaignV2Response, 'status' | 'errorCode' | 'errorMessage'>;
  className?: string;
};

/** Why a FAILED campaign did not go out; renders nothing for any other status. */
export const CampaignFailureCallout: FC<CampaignFailureCalloutProps> = ({ campaign, className }) => {
  const { t, i18n } = useTranslation('campaign');

  if (campaign.status !== 'FAILED') return null;

  return (
    <div className={twMerge('flex items-start gap-3 rounded-2xl border border-red-200 bg-red-50 px-4 py-3', className)} role='alert'>
      <HiOutlineExclamationCircle className='mt-0.5 size-5 shrink-0 text-red-700' aria-hidden />
      <div className='min-w-0 flex flex-col gap-0.5'>
        <p className='text-xs font-semibold uppercase tracking-[0.12em] text-red-700'>{t('campaignFailure.title')}</p>
        <p className='text-sm text-red-800'>{campaignFailureReason(campaign, t, i18n.language)}</p>
      </div>
    </div>
  );
};
